import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  containerAccordion: theme.containerAccordion,
  icon: {
    color: '#244e60',
    marginLeft: theme.spacing(1)
  },
  btnContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr'
  },
  button2: {
    height: 80,
    marginTop: 20,
    color: '#244e60'
  },
  btnColors: {
    width: 70,
    height: 40,
    marginTop: 10
  },
  accordionDetailsContainer: {
    display: 'grid',
    gridTemplateColumns: '100%'
  },
  sliderContainer: {
    display: 'grid',
    gridTemplateColumns: '5fr 1fr',
    width: '100%',
    alignItems: 'center',
    padding: 20
  },
  imgContainer: {
    backgroundColor: 'white',
    width: '100%',
    overflow: 'scroll'
  },
  buttonsf: {
    height: 40,
    border: 'none'
  }
}))
